import ArenaCompanyApi from '@/services/setup/ArenaCompanyApi'
import { CompanyDTO } from './CompanyV2'

export default class ArenaCompany extends CompanyDTO {
  static api = ArenaCompanyApi

  constructor(DTO: CompanyDTO) {
    super()
    Object.assign(this, DTO)
  }
}
